'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowFreeText = allowFreeText;

var _constantsUser = require('@bibliocommons/constants-user');

/**
 * Determines whether a user is allowed to add free text or not.
 * @param {userIdentityShape} user
 * @return {boolean}
 */
/* eslint-disable import/prefer-default-export */
function allowFreeText(user) {
  return !!(user && user.get('permissions')) && user.get('permissions').indexOf(_constantsUser.PERMISSIONS.UGC_FREE_TEXT) > -1;
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-user/lib/index.js
// module id = 234
// module chunks = 1